// extracted by mini-css-extract-plugin
export default {"questionHeader":"QuestionColumnHeader__questionHeader___SZ2eG","questionSerialHeader":"QuestionColumnHeader__questionSerialHeader___hN6SZ"};